// export const baseURL = 'https://adv-dashboard-api.sofisun.software';
export const baseURL = 'https://guppy-api.sofisun.software';
// export const baseURL = 'https://admin-api.clarityseek.com';

